var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 162,
    viewBox: "0 0 130 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 107.09V56.0266L126.785 67.8991L124.839 104.191L116.461 107.09Z",
    fill: "url(#paint0_linear_32504_60018)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4216 107.09V56.0266L3.09766 67.8991L5.04333 104.191L13.4216 107.09Z",
    fill: "url(#paint1_linear_32504_60018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4204 9.37073L15.4455 11.3561V82.0746L13.4204 83.4643V9.37073Z",
    fill: "url(#paint2_linear_32504_60018)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3568 7.82227V62.3402L3.09766 67.8992L5.04333 104.192L11.3568 106.375V133.138L13.4216 131.709V107.09V84.0204V60.9505V9.37084L11.3568 7.82227Z",
    fill: "url(#paint3_linear_32504_60018)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 75.7212L119.082 72.624V96.0513L123.45 93.51L124.403 75.7212Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 9.37073L114.396 11.3561V82.0746L116.461 83.4643V9.37073Z",
    fill: "url(#paint4_linear_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 113.006V113.284C108.797 113.84 109.234 114.277 109.79 114.277H112.172C112.728 114.277 113.165 113.84 113.165 113.284V113.006H108.797Z",
    fill: "url(#paint5_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 112.213H109.711C109.433 112.213 109.155 112.451 109.155 112.768C109.155 113.046 109.393 113.324 109.711 113.324H112.252C112.53 113.324 112.808 113.086 112.808 112.768C112.808 112.49 112.57 112.213 112.252 112.213Z",
    fill: "url(#paint6_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 118.049V118.327C108.797 118.883 109.234 119.32 109.79 119.32H112.172C112.728 119.32 113.165 118.883 113.165 118.327V118.049H108.797Z",
    fill: "url(#paint7_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 117.216H109.711C109.433 117.216 109.155 117.454 109.155 117.772C109.155 118.05 109.393 118.328 109.711 118.328H112.252C112.53 118.328 112.808 118.089 112.808 117.772C112.808 117.494 112.57 117.216 112.252 117.216Z",
    fill: "url(#paint8_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 122.973V123.251C108.797 123.807 109.234 124.244 109.79 124.244H112.172C112.728 124.244 113.165 123.807 113.165 123.251V122.973H108.797Z",
    fill: "url(#paint9_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 122.179H109.711C109.433 122.179 109.155 122.417 109.155 122.735C109.155 123.013 109.393 123.291 109.711 123.291H112.252C112.53 123.291 112.808 123.053 112.808 122.735C112.808 122.457 112.57 122.179 112.252 122.179Z",
    fill: "url(#paint10_linear_32504_60018)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 112.014H109.79C109.234 112.014 108.797 112.45 108.797 113.006C108.797 113.562 109.234 113.999 109.79 113.999H112.172C112.728 113.999 113.165 113.562 113.165 113.006C113.165 112.45 112.728 112.014 112.172 112.014Z",
    fill: "url(#paint11_linear_32504_60018)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 117.057H109.79C109.234 117.057 108.797 117.493 108.797 118.049C108.797 118.605 109.234 119.042 109.79 119.042H112.172C112.728 119.042 113.165 118.605 113.165 118.049C113.165 117.493 112.728 117.057 112.172 117.057Z",
    fill: "url(#paint12_linear_32504_60018)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 122.02H109.79C109.234 122.02 108.797 122.457 108.797 123.013C108.797 123.568 109.234 124.005 109.79 124.005H112.172C112.728 124.005 113.165 123.568 113.165 123.013C113.165 122.457 112.728 122.02 112.172 122.02Z",
    fill: "url(#paint13_linear_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4203 16.0414C14.4924 16.0414 15.3659 20.8459 15.3659 26.7623C15.3659 32.6787 14.4924 37.4833 13.4203 37.4833C12.3482 37.4833 11.4746 32.6787 11.4746 26.7623C11.4746 20.8459 12.3482 16.0414 13.4203 16.0414Z",
    fill: "url(#paint14_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M110.981 127.937C113.701 127.937 115.905 123.546 115.905 118.129C115.905 112.712 113.701 108.321 110.981 108.321C108.262 108.321 106.058 112.712 106.058 118.129C106.058 123.546 108.262 127.937 110.981 127.937Z",
    fill: "url(#paint15_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.87 15.1282C110.704 15.1282 111.379 20.9651 111.379 28.1918C111.379 35.4186 110.704 41.2555 109.87 41.2555C109.036 41.2555 108.361 35.4186 108.361 28.1918C108.361 20.9651 109.036 15.1282 109.87 15.1282Z",
    fill: "url(#paint16_radial_32504_60018)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.785 67.8992L118.526 62.3402V7.82227L116.461 9.37084V60.9505V84.0204V107.09V131.709L118.526 133.138V106.375L124.839 104.192L126.785 67.8992Z",
    fill: "url(#paint17_linear_32504_60018)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.479 75.7212L10.7601 72.624V96.0513L6.43194 93.51L5.479 75.7212Z",
    fill: "url(#paint18_linear_32504_60018)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82959 76.4755L9.45028 74.9269V93.7878L7.70315 92.7554L6.82959 76.4755Z",
    fill: "url(#paint19_radial_32504_60018)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43213 93.5099L7.70279 92.7555L9.44991 93.7879L10.7603 96.0512L6.43213 93.5099Z",
    fill: "url(#paint20_linear_32504_60018)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82903 76.4756L5.479 75.7212L10.7601 72.624L9.44972 74.927L6.82903 76.4756Z",
    fill: "url(#paint21_linear_32504_60018)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.479 75.7213L6.82903 76.4757L7.7026 92.7557L6.43194 93.5101L5.479 75.7213Z",
    fill: "url(#paint22_linear_32504_60018)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44971 93.788V74.927L10.7601 72.624V96.0513L9.44971 93.788Z",
    fill: "url(#paint23_linear_32504_60018)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.403 75.7212L119.082 72.624V96.0513L123.45 93.51L124.403 75.7212Z",
    fill: "url(#paint24_linear_32504_60018)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.013 76.4755L120.392 74.9269V93.7878L122.179 92.7554L123.013 76.4755Z",
    fill: "url(#paint25_radial_32504_60018)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.45 93.5099L122.179 92.7555L120.392 93.7879L119.082 96.0512L123.45 93.5099Z",
    fill: "url(#paint26_linear_32504_60018)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.013 76.4756L124.403 75.7212L119.082 72.624L120.392 74.927L123.013 76.4756Z",
    fill: "url(#paint27_linear_32504_60018)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.402 75.7213L123.013 76.4757L122.179 92.7557L123.449 93.5101L124.402 75.7213Z",
    fill: "url(#paint28_linear_32504_60018)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.392 93.788V74.927L119.082 72.624V96.0513L120.392 93.788Z",
    fill: "url(#paint29_linear_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13999 64.564C12.6269 64.564 16.28 73.4187 16.28 84.3779C16.28 95.337 12.6269 104.192 8.13999 104.192C3.65307 104.192 0 95.337 0 84.3779C0 73.4187 3.65307 64.564 8.13999 64.564Z",
    fill: "url(#paint30_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.743 64.564C126.229 64.564 129.883 73.4187 129.883 84.3779C129.883 95.337 126.229 104.192 121.743 104.192C117.256 104.192 113.603 95.337 113.603 84.3779C113.603 73.4187 117.256 64.564 121.743 64.564Z",
    fill: "url(#paint31_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M9.21135 124.68C8.25837 124.68 7.50391 106.614 7.50391 84.3776C7.50391 62.1416 8.25837 44.0748 9.21135 44.0748C10.1643 44.0748 10.9187 62.1416 10.9187 84.3776C10.9187 106.614 10.1643 124.68 9.21135 124.68Z",
    fill: "url(#paint32_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M7.30552 64.1671C7.70259 64.1671 8.02028 73.2203 8.02028 84.3384C8.02028 95.4564 7.70259 104.51 7.30552 104.51C6.90845 104.51 6.59082 95.4564 6.59082 84.3384C6.59082 73.2203 6.90845 64.1671 7.30552 64.1671Z",
    fill: "url(#paint33_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M120.67 124.641C121.613 124.641 122.377 106.596 122.377 84.3377C122.377 62.0791 121.613 44.0349 120.67 44.0349C119.727 44.0349 118.962 62.0791 118.962 84.3377C118.962 106.596 119.727 124.641 120.67 124.641Z",
    fill: "url(#paint34_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M122.616 104.509C123.011 104.509 123.331 95.4779 123.331 84.3376C123.331 73.1974 123.011 64.1664 122.616 64.1664C122.221 64.1664 121.901 73.1974 121.901 84.3376C121.901 95.4779 122.221 104.509 122.616 104.509Z",
    fill: "url(#paint35_radial_32504_60018)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0767 124.005V151.681L64.9229 158.908L85.8089 151.681V124.005H44.0767Z",
    fill: "#9B9B9B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3389 124.005V150.053L64.9219 156.526L83.5445 150.053V124.005H46.3389Z",
    fill: "url(#paint36_radial_32504_60018)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8081 124.005V151.681L88.0714 153.27V124.005H85.8081Z",
    fill: "url(#paint37_linear_32504_60018)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8083 151.681V124.005H83.5449V150.053L85.8083 151.681Z",
    fill: "url(#paint38_linear_32504_60018)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3399 150.053V124.005H44.0767V151.681L46.3399 150.053Z",
    fill: "url(#paint39_linear_32504_60018)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0758 151.681V124.005H41.8125V153.27L44.0758 151.681Z",
    fill: "url(#paint40_linear_32504_60018)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5951 153.587L64.9221 158.908V161.29L49.5951 155.97L41.8125 153.269L44.0758 151.681L49.5951 153.587Z",
    fill: "url(#paint41_linear_32504_60018)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9229 158.908L49.596 153.588L44.0767 151.682L46.3399 150.054L49.596 151.205L64.9229 156.526V158.908Z",
    fill: "url(#paint42_linear_32504_60018)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 158.908L80.289 153.587L85.8083 151.681L88.0716 153.269L80.289 155.97L64.9224 161.29V158.908Z",
    fill: "url(#paint43_linear_32504_60018)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8083 151.682L80.289 153.588L64.9224 158.908V156.526L80.289 151.205L83.545 150.054L85.8083 151.682Z",
    fill: "url(#paint44_linear_32504_60018)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4219 83.4647L15.4469 82.075L64.9221 99.1888V101.333L13.4219 83.4647Z",
    fill: "url(#paint45_linear_32504_60018)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 83.4647L114.397 82.075L64.9224 99.1888V101.333L116.462 83.4647Z",
    fill: "url(#paint46_linear_32504_60018)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 151.761V101.333L13.4222 83.4643L11.3574 82.7496V133.138L64.9224 151.761Z",
    fill: "url(#paint47_linear_32504_60018)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 101.333V151.761L118.527 133.138V82.7496L116.462 83.4643L64.9224 101.333Z",
    fill: "url(#paint48_linear_32504_60018)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 149.577L13.4222 131.709L11.3574 133.138L64.9224 151.761V149.577Z",
    fill: "url(#paint49_linear_32504_60018)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 131.709L64.9224 149.577V151.761L118.527 133.138L116.462 131.709Z",
    fill: "url(#paint50_linear_32504_60018)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4463 11.3565V81.9956L64.9215 99.1888L114.397 81.9956V11.3565L64.9215 4.12976L15.4463 11.3565Z",
    fill: "url(#paint51_radial_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.189 88.5467L103.677 9.80737L114.397 11.356V82.0745L64.9224 99.1883L34.189 88.5467Z",
    fill: "url(#paint52_radial_32504_60018)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.753 17.6696V30.2568L20.9265 28.4303V16.0814L64.9618 9.64879L93.4318 13.818V15.6446L64.9618 11.4753L22.753 17.6299V17.6696ZM22.753 31.5672V54.4782L20.0132 57.218V78.8187L64.9221 94.4236L109.831 78.8187V42.6058L109.751 42.5263L108.918 41.6925L107.091 39.866V17.7094L94.2657 15.8431V13.1033L64.9221 8.81494L20.0132 15.3666V28.8671L22.753 31.6069V31.5672ZM22.753 55.7488V76.8334L54.2805 87.7925V89.7382L20.9265 78.1437V57.5754L22.753 55.7488ZM55.1938 88.1102L64.9618 91.4853L74.7298 88.1102V90.0559L64.9618 93.431L55.1938 90.0559V88.1102ZM75.6033 87.7925L107.131 76.8334V41.1366L108.957 42.9631V78.1437L75.6033 89.7382V87.7925ZM23.6663 18.4638V76.198L64.9618 90.5323L106.257 76.198V18.4638L64.9618 12.4283L23.6663 18.4638Z",
    fill: "url(#paint53_radial_32504_60018)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4222 9.3709L64.9224 2.06478V0L11.3574 7.82232L13.4222 9.3709Z",
    fill: "url(#paint54_linear_32504_60018)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9221 2.06482L13.4219 9.37094L15.4469 11.3563L64.9221 4.1296V2.06482Z",
    fill: "url(#paint55_linear_32504_60018)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 9.3709L64.9224 2.06478V0L118.527 7.82232L116.462 9.3709Z",
    fill: "url(#paint56_linear_32504_60018)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 2.06482L116.462 9.37094L114.397 11.3563L64.9224 4.1296V2.06482Z",
    fill: "url(#paint57_linear_32504_60018)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.87 41.2559V15.2874L95.2183 13.1432V15.0094L108.044 16.8757V39.4691L109.87 41.2559Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0132 30.0977V55.9073L21.8397 54.0411V31.9242L20.0132 30.0977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9222 91.4855L55.1938 88.0707V90.0163L64.9222 93.3914L74.6901 90.0163V88.0707L64.9222 91.4855Z",
    fill: "url(#paint58_radial_32504_60018)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9224 111.26L63.9297 102.048L22.2769 86.5619L64.9224 101.333V111.26Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4213 50.7062L12.6668 9.64899L11.5947 8.021L13.5404 8.77544L29.9394 7.02832L13.4213 9.37105V50.7062Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8169 6.1943L64.4061 1.42944L64.9223 0.158813V2.06476L35.8169 6.1943Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.692 129.326H103.875V125.355H94.9407V109.949H90.692V129.326ZM74.8488 129.326H88.3096V125.355H79.0975V121.186H87.158V117.215H79.0975V113.88H88.3096V109.909H74.8488V129.286V129.326ZM67.0265 129.326L73.1811 110.703V109.075L69.2898 109.393L65.3191 121.305L64.9617 123.33H64.8426L64.4853 121.305L60.5145 109.393L56.6232 109.075V110.703L62.7778 129.326H66.9868H67.0265ZM41.5742 129.326H55.0349V125.355H45.8228V121.186H53.8835V117.215H45.8228V113.88H55.0349V109.909H41.5742V129.286V129.326ZM25.9692 129.326H39.1521V125.355H30.2179V109.949H25.9692V129.326Z",
    fill: "#4D5E6E"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.692 127.698H103.875V123.727H94.9407V108.321H90.692V127.698ZM74.8488 127.698H88.3096V123.727H79.0975V119.558H87.158V115.587H79.0975V112.252H88.3096V108.281H74.8488V127.658V127.698ZM67.0265 127.698L73.1811 109.075L69.2898 107.765L65.3191 119.677L64.9617 121.702H64.8426L64.4853 119.677L60.5145 107.765L56.6232 109.075L62.7778 127.698H66.9868H67.0265ZM41.5742 127.698H55.0349V123.727H45.8228V119.558H53.8835V115.587H45.8228V112.252H55.0349V108.281H41.5742V127.658V127.698ZM25.9692 127.698H39.1521V123.727H30.2179V108.321H25.9692V127.698Z",
    fill: "url(#paint59_linear_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6777 113.006V113.284C16.6777 113.84 17.1145 114.277 17.6704 114.277H20.0529C20.6088 114.277 21.0455 113.84 21.0455 113.284V113.006H16.6777Z",
    fill: "url(#paint60_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1329 112.213H17.5915C17.3136 112.213 17.0356 112.451 17.0356 112.768C17.0356 113.046 17.2739 113.324 17.5915 113.324H20.1329C20.4108 113.324 20.6888 113.086 20.6888 112.768C20.6888 112.49 20.4505 112.213 20.1329 112.213Z",
    fill: "url(#paint61_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6777 118.049V118.327C16.6777 118.883 17.1145 119.32 17.6704 119.32H20.0529C20.6088 119.32 21.0455 118.883 21.0455 118.327V118.049H16.6777Z",
    fill: "url(#paint62_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1329 117.216H17.5915C17.3136 117.216 17.0356 117.454 17.0356 117.772C17.0356 118.05 17.2739 118.328 17.5915 118.328H20.1329C20.4108 118.328 20.6888 118.089 20.6888 117.772C20.6888 117.494 20.4505 117.216 20.1329 117.216Z",
    fill: "url(#paint63_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6777 122.973V123.251C16.6777 123.807 17.1145 124.244 17.6704 124.244H20.0529C20.6088 124.244 21.0455 123.807 21.0455 123.251V122.973H16.6777Z",
    fill: "url(#paint64_linear_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1329 122.179H17.5915C17.3136 122.179 17.0356 122.417 17.0356 122.735C17.0356 123.013 17.2739 123.291 17.5915 123.291H20.1329C20.4108 123.291 20.6888 123.053 20.6888 122.735C20.6888 122.457 20.4505 122.179 20.1329 122.179Z",
    fill: "url(#paint65_linear_32504_60018)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0928 112.014H17.7105C17.1546 112.014 16.7178 112.45 16.7178 113.006C16.7178 113.562 17.1546 113.999 17.7105 113.999H20.0928C20.6487 113.999 21.0855 113.562 21.0855 113.006C21.0855 112.45 20.6487 112.014 20.0928 112.014Z",
    fill: "url(#paint66_linear_32504_60018)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0928 117.057H17.7105C17.1546 117.057 16.7178 117.493 16.7178 118.049C16.7178 118.605 17.1546 119.042 17.7105 119.042H20.0928C20.6487 119.042 21.0855 118.605 21.0855 118.049C21.0855 117.493 20.6487 117.057 20.0928 117.057Z",
    fill: "url(#paint67_linear_32504_60018)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0928 122.02H17.7105C17.1546 122.02 16.7178 122.457 16.7178 123.013C16.7178 123.568 17.1546 124.005 17.7105 124.005H20.0928C20.6487 124.005 21.0855 123.568 21.0855 123.013C21.0855 122.457 20.6487 122.02 20.0928 122.02Z",
    fill: "url(#paint68_linear_32504_60018)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0134 29.6212C21.3635 29.6212 22.4356 35.617 22.4356 43.0025C22.4356 50.3881 21.3635 56.3839 20.0134 56.3839C18.6634 56.3839 17.5913 50.3881 17.5913 43.0025C17.5913 35.617 18.6634 29.6212 20.0134 29.6212Z",
    fill: "url(#paint69_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M18.8617 127.937C21.581 127.937 23.7854 123.546 23.7854 118.129C23.7854 112.712 21.581 108.321 18.8617 108.321C16.1424 108.321 13.938 112.712 13.938 118.129C13.938 123.546 16.1424 127.937 18.8617 127.937Z",
    fill: "url(#paint70_radial_32504_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.64 101.333C70.64 104.47 68.0987 107.011 64.9619 107.011C61.825 107.011 59.2837 104.47 59.2837 101.333C59.2837 98.1958 61.825 95.6545 64.9619 95.6545C68.0987 95.6545 70.64 98.1958 70.64 101.333Z",
    fill: "url(#paint71_radial_32504_60018)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.252 64.1269L55.3919 72.3463H74.0941L82.234 64.1269V51.6589L74.0941 43.4395H61.2686L57.2185 44.3528V38.6349L59.7994 36.054H71.791L79.6928 38.6746L82.6311 29.8199L73.3793 26.7228H55.3919L47.252 34.9422V64.0872V64.1269ZM69.7262 52.7707L72.3072 55.3517V60.4739L69.7262 63.0548H59.7598L57.1788 60.4739V53.3663L59.6009 52.7707H69.6866H69.7262Z",
    fill: "url(#paint72_linear_32504_60018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32504_60018",
    x1: 116.461,
    y1: 81.5583,
    x2: 126.785,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32504_60018",
    x1: 3.09766,
    y1: 81.5583,
    x2: 13.4216,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32504_60018",
    x1: 13.4204,
    y1: 46.4175,
    x2: 15.4455,
    y2: 46.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32504_60018",
    x1: 3.09766,
    y1: 70.4802,
    x2: 13.4216,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32504_60018",
    x1: 114.396,
    y1: 46.4175,
    x2: 116.461,
    y2: 46.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32504_60018",
    x1: 110.981,
    y1: 114.277,
    x2: 110.981,
    y2: 113.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32504_60018",
    x1: 110.981,
    y1: 113.285,
    x2: 110.981,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32504_60018",
    x1: 110.981,
    y1: 119.28,
    x2: 110.981,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32504_60018",
    x1: 110.981,
    y1: 118.328,
    x2: 110.981,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32504_60018",
    x1: 110.981,
    y1: 124.244,
    x2: 110.981,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32504_60018",
    x1: 110.981,
    y1: 123.251,
    x2: 110.981,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32504_60018",
    x1: 110.981,
    y1: 113.999,
    x2: 110.981,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32504_60018",
    x1: 110.981,
    y1: 119.002,
    x2: 110.981,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32504_60018",
    x1: 110.981,
    y1: 123.966,
    x2: 110.981,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-40.5622 27.9742) rotate(-90) scale(10.6256 1.77093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.813 118.306) rotate(-90) scale(9.74017 4.87008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.972 26.6083) rotate(-90) scale(13.2559 1.657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32504_60018",
    x1: 116.461,
    y1: 70.4802,
    x2: 126.785,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32504_60018",
    x1: 8.13939,
    y1: 72.6637,
    x2: 8.13939,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.13993 84.3772) scale(6.71055 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32504_60018",
    x1: 8.57634,
    y1: 92.7555,
    x2: 8.57634,
    y2: 96.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32504_60018",
    x1: 8.13939,
    y1: 72.6637,
    x2: 8.13939,
    y2: 76.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32504_60018",
    x1: 6.5908,
    y1: 75.761,
    x2: 6.5908,
    y2: 93.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32504_60018",
    x1: 10.1247,
    y1: 72.6637,
    x2: 10.1247,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32504_60018",
    x1: 121.742,
    y1: 72.6637,
    x2: 121.742,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.702 84.3772) rotate(180) scale(6.7104 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32504_60018",
    x1: 121.266,
    y1: 92.7555,
    x2: 121.266,
    y2: 96.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_32504_60018",
    x1: 121.742,
    y1: 72.6637,
    x2: 121.742,
    y2: 76.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32504_60018",
    x1: 123.291,
    y1: 75.761,
    x2: 123.291,
    y2: 93.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32504_60018",
    x1: 119.757,
    y1: 72.6637,
    x2: 119.757,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1797 82.8821) rotate(-90) scale(20.2439 8.33574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.447 82.8821) rotate(-90) scale(20.2439 8.33574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4356 84.9593) rotate(-90) scale(40.2798 1.6415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-111.133 83.3854) rotate(90) scale(20.1315 0.805263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5223 84.9591) rotate(-90) scale(40.2798 1.6415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(432.074 83.3847) rotate(90) scale(20.1315 0.805263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9218 156.526) scale(19.4565 19.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B0FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9CFFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#89FFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#71FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#53FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#30FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#08FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32504_60018",
    x1: 85.8081,
    y1: 138.618,
    x2: 88.0714,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32504_60018",
    x1: 83.5449,
    y1: 137.823,
    x2: 85.8083,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32504_60018",
    x1: 44.0767,
    y1: 137.823,
    x2: 46.3399,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32504_60018",
    x1: 41.8125,
    y1: 138.618,
    x2: 44.0758,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32504_60018",
    x1: 41.8125,
    y1: 156.486,
    x2: 64.9221,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_32504_60018",
    x1: 44.0767,
    y1: 154.501,
    x2: 64.9229,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_32504_60018",
    x1: 64.9224,
    y1: 156.486,
    x2: 88.0716,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_32504_60018",
    x1: 64.9224,
    y1: 154.501,
    x2: 85.8083,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_32504_60018",
    x1: 13.4219,
    y1: 91.7238,
    x2: 64.9221,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_32504_60018",
    x1: 64.9224,
    y1: 91.7238,
    x2: 116.462,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_32504_60018",
    x1: 64.6445,
    y1: 101.491,
    x2: 7.94262,
    y2: 135.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A94C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_32504_60018",
    x1: 64.5253,
    y1: 101.055,
    x2: 120.354,
    y2: 134.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42689C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_32504_60018",
    x1: 11.3574,
    y1: 141.715,
    x2: 64.9224,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_32504_60018",
    x1: 64.9224,
    y1: 141.715,
    x2: 118.527,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9214 4.16947) scale(95.3767 95.3767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01429F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#033082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#042571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05226B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#091D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1C4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6643 -14.692) scale(126.189 126.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9985 15.7637) scale(127.778 127.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_32504_60018",
    x1: 11.3574,
    y1: 4.68545,
    x2: 64.9224,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7996B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_32504_60018",
    x1: 13.4219,
    y1: 6.71056,
    x2: 64.9221,
    y2: 6.71056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_32504_60018",
    x1: 64.9224,
    y1: 4.68545,
    x2: 118.527,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E76A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_32504_60018",
    x1: 64.9224,
    y1: 6.71056,
    x2: 116.462,
    y2: 6.71056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9221 90.7311) scale(1.98536 1.98535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_32504_60018",
    x1: 64.922,
    y1: 127.698,
    x2: 64.922,
    y2: 107.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_32504_60018",
    x1: 18.8616,
    y1: 114.277,
    x2: 18.8616,
    y2: 113.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_32504_60018",
    x1: 18.8622,
    y1: 113.285,
    x2: 18.8622,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_32504_60018",
    x1: 18.8616,
    y1: 119.28,
    x2: 18.8616,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#283B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1D6073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#14809E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0D9AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#07AEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#03BCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_32504_60018",
    x1: 18.8622,
    y1: 118.328,
    x2: 18.8622,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_32504_60018",
    x1: 18.8616,
    y1: 124.244,
    x2: 18.8616,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_32504_60018",
    x1: 18.8622,
    y1: 123.251,
    x2: 18.8622,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_32504_60018",
    x1: 18.8619,
    y1: 113.999,
    x2: 18.8619,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_32504_60018",
    x1: 18.8619,
    y1: 119.002,
    x2: 18.8619,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_32504_60018",
    x1: 18.8619,
    y1: 123.966,
    x2: 18.8619,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-34.5332 44.0317) rotate(-90) scale(13.2558 2.20931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9425 118.306) rotate(-90) scale(9.74017 4.87011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_32504_60018",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9221 101.333) scale(5.67813 5.67812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1798C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#127498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0D556F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#093B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#052530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#01090B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#000202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_32504_60018",
    x1: 82.1546,
    y1: 64.2858,
    x2: 50.0315,
    y2: 32.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/level6.f15c68240a032207ad93b413fbc9f129.svg";
export { ForwardRef as ReactComponent };